import React from "react";
import "./App.scss";

import CalendarView from "shared/CalendarView/CalendarView.shared";
import AuthenticatePane from "./features/auth/AuthenticatePane.js";
import MainListView from "shared/itemLists/MainListView/MainListView.shared.js";
import ItemView from "./features/ItemView/ItemView";
import ChecklistView from "./features/checklists/ChecklistView.js";
import TimeCorrectionPane from "./features/itemLists/TimeCorrectionPane";
import Header from "./features/header/Header";
import FlashMessageContainer from "./features/flashMessages/FlashMessageContainer";

import { fetchPlan } from "shared/itemLists/redux/itemListsSlice";

import AppComponent from "shared/App.shared";

export default class App extends React.Component {
  renderApp(props) {
    const {
      sharedMainListViewProps,
      setToken,
      setIsLoggedIn,
      setFlashMessage,
      setSelectedDate,
      setScrollOffset,
      setOpenChecklist,
      handleNewTaskButtonClick,
      setIsSomeday,
      resetAppState,

      planItems,
      doneItems,
      hasBlankTask,
      setPrimaryCalendarId,
      openItem,
      timeCorrectionObject,

      canEnterItem,
      isLoggedIn,
      flashMessage,
      dateHelper,
      selectedDate,
      isSomeday,
      lastDay,
      scrollOffset,
      listType,
      openChecklist,
    } = props;

    return (
      <div className="App">
        <Header
          {...{
            handleNewTaskButtonClick,
            canEnterItem,
            hasBlankTask,
            setIsLoggedIn,
            isLoggedIn,
            resetAppState,
          }}
        />
        <div className="app-body">
          <FlashMessageContainer flashMessage={flashMessage} />

          <AuthenticatePane
            setToken={setToken}
            setFlashMessage={setFlashMessage}
            setPrimaryCalendarId={setPrimaryCalendarId}
            setIsLoggedIn={setIsLoggedIn}
            isLoggedIn={isLoggedIn}
          />

          <CalendarView
            dateHelper={dateHelper}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            isSomeday={isSomeday}
            setIsSomeday={setIsSomeday}
            calendarItems={listType === "Done" ? doneItems : planItems}
            hasBlankTask={hasBlankTask}
            lastDay={lastDay}
            disabled={listType === "Act"}
            direction={listType === "Done" ? "reverse" : "forward"}
            scrollOffset={scrollOffset}
            setScrollOffset={setScrollOffset}
            offsetAboveSelectedDate={100}
          ></CalendarView>

          {timeCorrectionObject.isOpen && (
            <TimeCorrectionPane {...timeCorrectionObject} />
          )}

          {isLoggedIn && <MainListView {...sharedMainListViewProps} />}
          {openItem.isOpen && (
            <ItemView
              setOpenChecklist={setOpenChecklist}
              dateHelper={dateHelper}
            />
          )}

          {openChecklist.isOpen && (
            <ChecklistView
              openChecklist={openChecklist}
              setOpenChecklist={setOpenChecklist}
            />
          )}
        </div>
      </div>
    );
  }

  render() {
    return (
      <AppComponent
        fixedDate={this.props.fixedDate}
        renderApp={this.renderApp}
      />
    );
  }
}
